import RouteManager from '../components/routeManager.js'
import FilterManager from '../components/filterManager.js'

export default {
    methods: {
        viewRelated: function (query, clear_all = false) {
            RouteManager.setForce(true)
            RouteManager.clearPage()


            if (clear_all) {
                FilterManager.clearAll()
            }

            // Add new params in query to filters
            FilterManager.addByQuery(query)

            // Regenerate the query
            query = FilterManager.generateQuery()

            // Initialize new search
            this.$router.push({name: 'search', query: query})
        },

        generateLink: function (query, clear_all = false) {
            // Combine with existing params
            if (!clear_all) {
                // query = Object.assign(query, FilterManager.generateQuery())
                const existingQuery = FilterManager.generateQuery();
                query = { ...existingQuery, ...query };
            }

            // Generate url from params
            var url = "";
            for (var prop in query) {
                if (Array.isArray(query[prop])) {
                    query[prop].forEach(function (e) {
                        url += prop + "=" + encodeURIComponent(e) + "&";
                    })
                } else {
                    url += prop + "=" + encodeURIComponent(query[prop]) + "&";
                }
            }

            // Trim &
            url = url.slice(0, -1)

            return "/search?" + url
        },

        generateLinkNew: function (query, clear_all = false) {
            // Generate url from params
            var url = "";
            for (var prop in query) {
                if (Array.isArray(query[prop])) {
                    query[prop].forEach(function (e) {
                        url += prop + "=" + encodeURIComponent(e) + "&";
                    })
                } else {
                    url += prop + "=" + encodeURIComponent(query[prop]) + "&";
                }
            }

            // Trim &
            url = url.slice(0, -1)

            const currentUrl = window.location.href;
            const queryParams = this.getQueryParams(currentUrl);

            return this.removeDuplicateParams("/search?" + url + queryParams);
        },
        getQueryParams(url) {
            const urlObj = new URL(url);
            const params = urlObj.searchParams;

            // If there are no query parameters, return an empty string
            if (params.toString() === "") {
                return "";
            }

            // Return the query string prefixed with '&'
            return '&' + params.toString();
        }, removeDuplicateParams(url) {
            const urlObj = new URL(url, window.location.origin); // Use window.location.origin as base if it's a relative URL
            const params = urlObj.searchParams;

            // Create a new URLSearchParams object to store unique parameters
            const uniqueParams = new URLSearchParams();

            // Loop through all parameters and add only unique ones
            params.forEach((value, key) => {
                if (!uniqueParams.has(key)) {
                    uniqueParams.set(key, value);
                }
            });

            // Return the URL with unique query parameters
            return urlObj.pathname + (uniqueParams.toString() ? '?' + uniqueParams.toString() : '');
        }
    }
}
